<script lang="ts">
    import Fa from 'svelte-fa'
    import {link,push} from 'svelte-spa-router'
    import * as qs from 'qs';
    import { faLine } from '@fortawesome/free-brands-svg-icons';
    import { faRing,faCoins,faCircleDollarToSlot,faHouse,faUnlockKeyhole,faRightFromBracket,faComment,faHome,faWallet,faXmark,faMoneyBillTransfer,faClockRotateLeft,faHandHoldingDollar,faFutbolBall,faBars,faCogs,faTent,faMoneyBillTrendUp,faSackDollar,faGifts,faCircleXmark,faGift,faUserTie,faUsers,faMoneyBills,faHandsHoldingCircle, faLongArrowAltUp } from '@fortawesome/free-solid-svg-icons';
    import Device from 'svelte-device-info'
    import Time from "svelte-time";
    import Swal from 'sweetalert2'
    import { launchMinigame } from '../../minigame';
    let dataSettingF = JSON.parse(window.localStorage.getItem('setting'))
    let balance = 0.00
    let acc_name =""

    let numnoti = ''
    let footerLoad = false
    async function getBalance() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getbalance", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            balance = json.payload.balance.toLocaleString('th-TH')
            acc_name = json.payload.username
		} else {
            window.localStorage.clear();
            push('/')
            throw new Error(json);
		}
    }
    getBalance()

    async function checkPromotion() {
        let couponx = ""
        Swal.fire({
            title: "กรุณาระบุ Code",
            input: "text",
            inputAttributes: {
                autocapitalize: "off",
                align: "center"
            },
            showCancelButton: true,
            confirmButtonText: "ยืนยัน",
            cancelButtonText: "ยกเลิก",
            showLoaderOnConfirm: true,
            preConfirm: async (login) => {
                try {
                    couponx = login
                    const res = await fetch(window.localStorage.getItem("apiurl")+"member/getpromotioncode", {
                        method: 'POST',
                        headers:{
                            'Content-Type': 'application/x-www-form-urlencoded',
                            'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                            'x-api-appid': window.localStorage.getItem("appid")
                        },
                        body: qs.stringify({
                            _id:login
                        })
                    })
                    const json = await res.json()
                    return json
                } catch (error) {
                    Swal.showValidationMessage(`
                        Request failed: ${error}
                    `);
                }
            },
            allowOutsideClick: () => !Swal.isLoading()
        }).then((result) => {
            
            if (result.isConfirmed) {
                // Swal.fire({
                // title: `${result.value.login}'s avatar`,
                // imageUrl: result.value.avatar_url
                // });
                if(result.value.statusCode == 200){
                    window.localStorage.setItem("coupon",couponx)
                    push('/promotion/'+result.value.payload._id)
                    
                }else{
                    window.localStorage.setItem("coupon","")
                    Swal.fire(result.value.message)
                }
            }else{
                
            }
        });
    }

    async function countMessage() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/countmessage", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) { 
            if(json.payload.total>=1){
                numnoti = json.payload.total
            }else{
                numnoti = ''
            }
            
		} else {
            throw new Error(json);
		}
    }
    // countMessage()

    let isRank = false
    let rankname = ""
    let rankimg = ""
    let percentagex = 0
    async function setFooterLoad() {
          if(footerLoad==false){
            footerLoad=true
          }else{
            footerLoad=false
          }
    }
    async function getRank() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getranking", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            if(json.payload.status){
                rankname = json.payload.rank_name
                rankimg = json.payload.rank_img
                let setA = json.payload.up_max-json.payload.up_min
                let setB = json.payload.scores-json.payload.up_min
                percentagex = Math.ceil((100*setB)/setA)
                isRank = true
            } 
		} else {
            
		}
    }
    async function LogoutFooter() {
        // loading = true
                window.localStorage.clear();
                setTimeout(() => {
                    window.location.href = dataSettingF.member_url+'/#/auth'
                }, 1000);
                // push('/')
    }
    let ufabetset =false;
    let isOnlyUFAF =false;
    let platformListF =[];
    let device = 'desktop' 
    async function getPlatformF() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/getplatformlist", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            platformListF = json.payload
            let dataPL = []
            dataPL = JSON.parse(dataSettingF.platform)
            for await (let abs of platformListF) {
                var xx= 0;
                for await (let val2 of dataPL) {
                    if(abs._id==val2){
                        xx=xx+1
                        break;
                    }
                }
                if(xx>0){
                    if(abs.platform_prefix=='UFA'){
                        ufabetset = true
                    }
                }
                
            }
            if(ufabetset==true&&dataPL.length==1){isOnlyUFAF=true}
		} else {

            throw new Error(json);
		}
    }
    async function getGameURLF(mgds) {
        Swal.fire({
            title: 'กรุณารอสักครู่',
            html: 'เรากำลังพาคุณเข้าสู่เกม ขอให้โชคดี Good Luck.',
            timer: 5000,
            timerProgressBar: true,
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading()
            },
            willClose: () => {
                
            }
        }).then((result) => {
            if (result.dismiss === Swal.DismissReason.timer) {
                
            }
        })
        
        if(Device.isPhone){
            device = 'mobile'
        }
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/startgame", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                _id:mgds,
                device:device,
                type:""
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            transferCashF(json.txid,json.payload)
		} else {
            if(json.statusCode==205){
                Swal.fire({
                    title: "ไม่สามารถเล่นเกมได้",
                    text: json.message,
                    icon: "warning",
                    showCancelButton: true,
                    confirmButtonColor: "#3085d6",
                    cancelButtonColor: "#d33",
                    confirmButtonText: "ยกเลิกโปรโมชั่น",
                    cancelButtonText: "ปิด"
                    }).then((result) => {
                    if (result.isConfirmed) {
                        clearpromotionF()
                    }
                });
            }else{
                Swal.fire(json.message)
            }
            throw new Error(json);
		}
        
    }
    async function transferCashF(txid,url) {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/transfercash", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({
                txid:txid
            })
        })
        const json = await res.json()
        if (json.statusCode==200) {
            // window.location = url
            window.open(url) 
            popUpGameF(url)
		} else {

            throw new Error(json);
		}
    }
    async function popUpGameF(url) {
        Swal.fire({
            title: '<strong><a href="'+url+'" target="_blank">เข้าสู่เกม</a></strong>',
            icon: 'info',
            html:
                'หากระบบไม่เปิดหน้าเกมอัตโนมัติกรุณาคลิกที่ปุ่ม <a href="'+url+'" target="_blank">เข้าสู่เกม</a>',
            showCloseButton: true,
            showCancelButton: false,
            showConfirmButton:false,
            focusConfirm: false
        })
    }
    async function clearpromotionF() {
        const res = await fetch(window.localStorage.getItem("apiurl")+"member/clearpromotion", {
            method: 'POST',
            headers:{
                'Content-Type': 'application/x-www-form-urlencoded',
                'Authorization': 'Bearer '+window.localStorage.getItem('access_token'),
                'x-api-appid': window.localStorage.getItem("appid")
            },
            body: qs.stringify({})
        })
        const json = await res.json()
        if (json.statusCode==200) {
            Swal.fire(json.message)
		} else {
            Swal.fire(json.message)
            throw new Error(json);
		}
    }
    getPlatformF()
    getRank()
</script>
<footer class="fixed bottom-0 w-full z-10">
    
    <footer class="mx-auto bg-[transparent] fixed bottom-[-2px] footer h-[80px] w-full flex">
        <div class="bg-wrapper w-full flex">
            <div class="w-full bg-gradient-wrapper"></div>
            <svg data-v-ff1a1022="" width="112" height="80" viewBox="0 0 112 80" fill="none" xmlns="http://www.w3.org/2000/svg" class="mx-[-1px]"><g clip-path="url(#clip0_6129_102583)"><path d="M0 0C8.06271 0 15.5318 3.23866 19.6663 10.1606L21.366 13.0061C37.3247 39.7235 76.4234 38.6903 91.287 11.3484C95.408 3.76785 103.372 0 112 0V79H57.5H0V0Z" fill="var(--primary3)"></path><path d="M0 0C8.06271 0 15.5318 4.23866 19.6663 11.1606L21.366 14.0061C37.3247 40.7235 76.4234 39.6903 91.287 12.3484C95.408 4.76785 103.372 0 112 0V80H57.5H0V0Z" fill="url(#paint0_linear_6129_102583)"></path></g><defs>
                <linearGradient id="paint0_linear_6129_102583" x1="56" y1="0" x2="56" y2="80" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stop-color="#202022"></stop>
                    <stop offset="1" stop-color="#0f0f10"></stop>
                </linearGradient>
                <clipPath id="clip0_6129_102583"><rect width="112" height="80" fill="white"></rect></clipPath></defs>
            </svg>
            <div class="w-full bg-gradient-wrapper"></div>
        </div>
        <div class="navigate-wrapper">
            <div class="navigate-container md:max-w-[630px] gap-2 px-2 p-[unset] !pb-[8px] base-container-small">
                <div class="grid grid-cols-5 grid-rows-1 w-full place-items-center gap-0">
                    <div class="cursor-pointer item active">
                        {#if isOnlyUFAF==false}
                        <div class="relative footer-item-content" on:click={() => setFooterLoad()}>
                            <span class="nuxt-icon text-[25px] footer-icon">
                                {#if footerLoad==false}
                                <Fa icon={faBars} size="md"/>
                                {:else}
                                <Fa icon={faXmark} size="md"/>
                                {/if}
                            </span>
                            <span class="menu-label footer-label">เมนู</span>
                        </div>
                        {:else}
                        <div class="relative footer-item-content"  on:click={() => push('/dashboard')}>
                            <span class="nuxt-icon text-[25px] footer-icon"><Fa icon={faHouse} size="md"/></span>
                            <span class="menu-label footer-label">หน้าหลัก</span>
                        </div>
                        {/if}
                    </div>

                    
                    <div class="cursor-pointer item">
                        <div class="relative footer-item-content"  on:click={() => push('/deposit')}>
                            {#if isOnlyUFAF==false}
                            <span class="nuxt-icon text-[25px] footer-icon"><Fa icon={faMoneyBillTrendUp} size="md"/></span>
                            {:else}
                            <span class="nuxt-icon text-[25px] footer-icon"><Fa icon={faCircleDollarToSlot} size="md"/></span>
                            {/if}
                            <span class="menu-label footer-label">ฝากเงิน</span>
                        </div>
                    </div>
                    <div class="cursor-pointer deposit-wrapper" style="position: relative;">
                        {#if isOnlyUFAF==false}
                        <a href="javascript:;"  on:click={() => push('/provider/GMZ/casino')}    style="text-decoration: none;color:#FFF;">
                        <div class="mincicle">
                            <img src="{dataSettingF.logo_wallet}">
                        </div>
                        <span class="txts">เข้าเล่น</span>
                        </a>
                        {:else}
                        <a href="javascript:;" class="ufabet"   on:click={() => getGameURLF('UFA')}  style="text-decoration: none;color:#FFF;">
                        <div class="mincicle">
                            <img src="./assets/icon/ufaplay.png">
                        </div>
                        <span class="txts">เข้าเล่น</span>
                        </a>
                        {/if}
                    </div>
                    <div class="cursor-pointer item">
                        <div class="relative footer-item-content"  on:click={() => push('/withdraw')}>
                             {#if isOnlyUFAF==false}
                            <span class="nuxt-icon text-[25px] footer-icon"><Fa icon={faSackDollar} size="md"/></span>
                            {:else}
                            <span class="nuxt-icon text-[25px] footer-icon"><Fa icon={faCoins} size="md"/></span>
                            {/if}
                            <span class="menu-label footer-label">ถอนเงิน</span>
                        </div>
                    </div>
                    <div class="cursor-pointer item ">
                        <div class="relative footer-item-content" >
                            <a href="{dataSettingF.lineurl}" target="_blank" style="text-decoration: none;color:#FFF;">
                                <span class="nuxt-icon text-[25px] footer-icon"><Fa icon={faLine} size="md"/></span>
                                <span class="menu-label footer-label">ติดต่อ</span>
                            </a>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </footer>
</footer>
{#if footerLoad}
<div class="blog-gooter-menu">
    <div class="row" style="margin: 0px;">
       <div class="col-12 text-center mt-5" style="padding-left:80px;padding-right:80px;" >
            <h4  class="header-n">เมนู</h4>
        </div>
    <button type="button" class="btn-xmark"  on:click={() => footerLoad=false}><Fa icon={faCircleXmark} size="md" style="color:red;"/></button>
    <div class="col-12 col-sm-1"></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" on:click={() => push('/dashboard')}><Fa icon={faHome} size="md" style="color:#b90b4b;"/> หน้าแรก</button></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" on:click={() => push('/setting')}><Fa icon={faUserTie} size="md" style="color:gold;"/> ข้อมูลสมาชิก</button></div>
    <div class="col-12 col-sm-1"></div>

    <div class="col-12 col-sm-1"></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" on:click={() => push('/history')}><Fa icon={faMoneyBillTrendUp} size="md" style="color:#18ab8f;"/> ประวัติฝาก-ถอน</button></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" on:click={() => push('/affiliate')}><Fa icon={faUsers} size="md" style="color:red;"/> รับทรัพย์</button></div>
    <div class="col-12 col-sm-1"></div>

    <div class="col-12 col-sm-1"></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" on:click={() => push('/cashback')}><Fa icon={faMoneyBills} size="md" style="color:#b7651c;"/> คืนยอดเสีย</button></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" on:click={() => push('/promotion')}><Fa icon={faGift} size="md" style="color:#2bc2ff;"/> โปรโมชั่น</button></div>
    <div class="col-12 col-sm-1"></div>

    <div class="col-12 col-sm-1"></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button"  on:click={() => checkPromotion()}><Fa icon={faHandsHoldingCircle} size="md" style="color:#fb26b8;"/> เติมโค้ด</button></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" on:click={() => push('/resetpasswordmeta')}><Fa icon={faUnlockKeyhole} size="md" style="color:#2bc2ff;"/> เปลี่ยนรหัส (PIN)</button></div>
    <div class="col-12 col-sm-1"></div>

    <div class="col-12 col-sm-1"></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button"  on:click={() => launchMinigame()}><Fa icon={faRing} size="md" style="color:#26fb54;"/> กงล้อเสี่ยงโชค</button></div>
    <div class="col-6 col-sm-5 mt-2 blogx"><button type="button" class="logouts" on:click={() => LogoutFooter()} style="background: #a50b0b;"> ออกจากระบบ <Fa icon={faRightFromBracket} size="md"/></button></div>
    <div class="col-12 col-sm-1"></div>

    <!-- <div class="col-12 col-sm-3"></div>
    <div class="col-12 col-sm-6 mt-2 blogx"><button type="button" class="logouts" on:click={() => LogoutFooter()} style="background: #a50b0b;"> ออกจากระบบ <Fa icon={faRightFromBracket} size="md"/></button></div>
    <div class="col-12 col-sm-3"></div> -->
    </div>
</div>
{/if}
<style>
    .blog-gooter-menu{
        position: fixed;
        top: 45px;
        width: 374px;
        height: 82%;
        background: #000000d9;
        z-index: 99;
    }
    .blog-gooter-menu .blogx{
        padding: 5px;
    }
    .blog-gooter-menu .blogx button{
        width: 100%;
        background: #404040;
        border: none;
         border-radius: 10px;
        align-items: center;
        width: 100%;
        padding: .75rem;
        transition: background .2s;
        color: #FFF;
    }
    .blog-gooter-menu .btn-xmark{
        width: 50px;
        background: transparent;
        border: 0px;
        padding: 0px;
        position: absolute;
        right: 0;
        top: 8px;
        /* color: #FFF; */
        font-size: 25px;
    }
    .navbar>.content-wrapper, .content-wrapper{
		/* width: 373px!important;
    	max-width: 374px!important; */
		min-height: 100%;
		display: table;
	}
    .w-20{
        width: 18%!important;
        width: 70px;
    }
    .btn-footer{
        color: white;
        background-color: transparent;
        border: 0px;
        cursor: pointer;
    }
   .bigbtn{
        background: linear-gradient(180deg, #ecc857 0%, #cf8000 100%);
        /* position: absolute; */
        width: 75px;
        height: 75px;
        position: absolute;
        left: 0px;
        top:-30px;
        color:white;
   }

   @media only screen and (min-device-aspect-ratio:1920 / 1080){
        .navbar>.content-wrapper, .content-wrapper{
            width: 373px!important;
            max-width: 374px!important;
            min-height: 100%;
            display: table;
        }

	}
	@media only screen and (min-device-aspect-ratio:512/683){
		.navbar>.content-wrapper, .content-wrapper{
            width: 373px!important;
            max-width: 374px!important;
            min-height: 100%;
            display: table;
        }
	}
    :global(.footer .deposit-wrapper .mincicle img){
        width: 100%;
        animation-name: rotates;
        animation-duration: 5s;
        animation-iteration-count: infinite;
        animation-timing-function: linear;
    }
    :global(.footer .deposit-wrapper .ufabet .mincicle img){
        animation-name: unset !important;
        box-shadow: 0 4px 8px 0 rgb(149 115 14), 0 6px 20px 0 #775a01;
        border: solid 0px #1b0700;
        border-radius: 50%;
        padding: 0px;
        margin: 0px !important;
    }
    :global(.footer .deposit-wrapper .mincicle){
        position: absolute;
        width: 80px;
        left: -27px;
        bottom: 28px;
    }
    :global(.footer .deposit-wrapper .ufabet .mincicle){
        position: absolute;
        width: 80px;
        left: -40px;
        bottom: 0px;
    }
    :global(.themes.default .footer .deposit-wrapper .ufabet .txts){
        position: absolute;
        top: 46px;
        left: 23px;
        color: gold;
    }
    @keyframes rotates{
        from{ transform: rotate(-360deg); }
        to{ transform: rotate(360deg); }
    }
     :global(.themes.default .footer .deposit-wrapper .txts){
        position: relative;
        bottom: -16px;
        left: 0;
        font-size: 9px;
    }
   @media only screen and (max-width: 767px) {
    .blog-gooter-menu{
        width:100%;
        height: 81%;
    }
    :global(.themes-home-default .row){
        margin: 0px !important;
    }
    .blog-gooter-menu .blogx{
        font-size: 20px !important;
    }
    .blog-gooter-menu{
        position: fixed;
        top: 66px;
    }
     :global(.themes.default .footer .deposit-wrapper .txts){
        position: absolute;
        top: 20px;
        left: 20px;
        font-size: 14px;
    }
    :global(.themes.default .footer .deposit-wrapper .ufabet .txts) {
        position: absolute;
        top: 46px;
        left: 20px;
        color: gold;
    }
    :global(.footer .deposit-wrapper .mincicle){
        left: 0px !important;
    }
   }

</style>
